import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import Certifications from "../About/Certifications";

function CertificationsPage() {
  return (
    <Container fluid className="certifications-page">
      <Particle />
      <Container>
        <Certifications />
      </Container>
    </Container>
  );
}

export default CertificationsPage;
